import { Phone, MessageCircle, Instagram } from "lucide-react";
import { site, assets } from "@/config/site";
import { services } from "@/data/services";

export const Footer = () => (
    <footer className="border-t border-rz-steel/60 bg-rz-carbon">
        <div className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:px-12">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <div className="flex items-center gap-3">
                        <img
                            src={assets.emblemTransparent}
                            alt="Revautoz RL emblem"
                            loading="lazy"
                            className="h-10 w-10 object-contain"
                        />
                        <div>
                            <p className="font-display text-lg font-bold uppercase tracking-[0.18em] text-rz-white">
                                Revautoz
                            </p>
                            <p className="font-display text-[10px] uppercase tracking-[0.22em] text-rz-smoke">
                                by Apex Automotive
                            </p>
                        </div>
                    </div>
                    <p className="mt-5 max-w-[40ch] text-sm leading-relaxed text-rz-smoke">
                        Premium automotive detailing, protection, restoration and customization in
                        Mapusa, Goa.
                    </p>
                    <p className="mt-4 max-w-[44ch] text-sm leading-relaxed text-rz-smoke">
                        Revautoz is a premium studio for car detailing in Goa — paint protection
                        film, ceramic coating, paint correction, restoration, car customization and
                        bodyshop repairs — based in Colvale, Mapusa and serving Bardez and all of
                        North Goa.
                    </p>
                </div>
                <nav aria-label="Footer sections" className="lg:col-span-2">
                    <p className="font-display text-[11px] uppercase tracking-[0.22em] text-rz-smoke">
                        Explore
                    </p>
                    <ul className="mt-4 space-y-2.5">
                        {[
                            ["Services", "#services"],
                            ["Our Work", "#work"],
                            ["About", "#about"],
                            ["Studio", "#studio"],
                            ["Contact", "#contact"],
                        ].map(([l, h]) => (
                            <li key={h}>
                                <a
                                    href={h}
                                    className="text-sm text-rz-white/80 transition-colors hover:text-rz-red"
                                >
                                    {l}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <nav aria-label="Footer services" className="lg:col-span-3">
                    <p className="font-display text-[11px] uppercase tracking-[0.22em] text-rz-smoke">
                        Services
                    </p>
                    <ul className="mt-4 grid grid-cols-2 gap-2.5">
                        {services.map((s) => (
                            <li key={s.id}>
                                <a
                                    href="#services"
                                    className="text-sm text-rz-white/80 transition-colors hover:text-rz-red"
                                >
                                    {s.name} Goa
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="lg:col-span-3">
                    <p className="font-display text-[11px] uppercase tracking-[0.22em] text-rz-smoke">
                        Studio
                    </p>
                    <address className="mt-4 text-sm not-italic leading-relaxed text-rz-white/80">
                        {site.address.lines.slice(1).map((l) => (
                            <span key={l} className="block">
                                {l}
                            </span>
                        ))}
                    </address>
                    <div className="mt-4 space-y-2">
                        <a
                            data-testid="footer-phone"
                            href={`tel:${site.phone}`}
                            className="flex items-center gap-2 text-sm text-rz-white/80 transition-colors hover:text-rz-red"
                        >
                            <Phone size={13} className="text-rz-red" /> {site.phoneDisplay}
                        </a>
                        <a
                            data-testid="footer-whatsapp"
                            href={site.whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-sm text-rz-white/80 transition-colors hover:text-rz-red"
                        >
                            <MessageCircle size={13} className="text-rz-red" /> WhatsApp the studio
                        </a>
                        <a
                            data-testid="footer-instagram"
                            href={site.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-sm text-rz-white/80 transition-colors hover:text-rz-red"
                        >
                            <Instagram size={13} className="text-rz-red" /> {site.instagramHandle}
                        </a>
                    </div>
                </div>
            </div>
            <div className="mt-14 flex flex-col gap-3 border-t border-rz-steel/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-xs text-rz-smoke">
                    © {new Date().getFullYear()} Revautoz — by Apex Automotive. All rights reserved.
                </p>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-rz-smoke">
                    Ride. Redefined.
                </p>
            </div>
        </div>
    </footer>
);
